
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, Inject, Injectable } from '@angular/core';
import { RouterLink } from '@angular/router/src/directives/router_link';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { DefaultTS } from '../SharedComponents/Default';
import { ChangeDetectorRef, NgZone } from '@angular/core';
import { element } from 'protractor';
import { PersistenceService, StorageType } from 'angular-persistence';

@Injectable()
@Component({
  selector: 'Login',
  templateUrl: './Login.html',
  styleUrls: ['./Login.css']
})
export class Login {
  public http: HttpClient;
  public baseUrl: string;
  // **SSO**
  public refc = '';
  public IsJLRSSO = false;
  public UserName = '';
  public Password = '';
  public CurrentYear = 2022 as any;
  public sub: any = {} as any;
  public ReturnURL = '' as any;
  public l_boolIsSSO = false;
  public ShouldShowLogIn = false;
  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string, private router: Router, private cd: ChangeDetectorRef, private zone: NgZone, private router2: ActivatedRoute, public DefaultTS: DefaultTS, private persistenceService: PersistenceService) {
    this.http = http;
    this.baseUrl = baseUrl;
    var l_strSSoResponse = '';
    var logOutRequired = false;
    this.CurrentYear = new Date().getFullYear(); // returns the current year
    this.persistenceService.removeAll(StorageType.SESSION);
    var l_boolNeedToGoForLoginApp = false;
    var l_strIsLogout = false;
    var SSO = 0 as any;
    this.router2.queryParams
      .subscribe(params => {
        if (params.logout && (params.logout == 1 || params.logout == "1")) {
          logOutRequired = true;
        } else {
          if (params.refc) {
            // **SSO**
            this.refc = params.refc;
            if (!this.DefaultTS.IsLocal)
              this.IsJLRSSO = true;
          }
          else {
            if (+params.sso) {
              SSO = +params.sso;
            }
            if (params.ReturnURL)
              this.ReturnURL = decodeURIComponent(params.ReturnURL);
            if (params.q) {
              this.l_boolIsSSO = true;
              l_strSSoResponse = params.q;
            }
            if (params.lo) {
              l_strIsLogout = true;
            }
          }
        }
      });
    if (logOutRequired) {
      this.GetMeLoggedOutAndRedirect();
    } else if (this.IsJLRSSO) {
      // **SSO**
      this.DefaultTS.AddLoginLog(4367, this.refc);
      var URL = window.location.href;
      this.VerifyUser(false, this.refc, URL, true);
    } else {

      if (SSO == 1) {
        let data = {} as any;
        this.http.post(this.baseUrl + 'api/SiteUser/LogoutUser', data).subscribe(result => {
          this.router.navigate(['/login']);
        }, error => console.error(error));
      }
      else {

        this.DefaultTS.PTSetVisibilty('sidebar-collapse', false);
        document.getElementById('page_content').setAttribute('style', 'width:100% !important;');
        this.DefaultTS.PTSetVisibilty('divLeftMenu', false);
        this.DefaultTS.PTSetVisibilty('ULTopMenuItems', false);


        if (this.l_boolIsSSO) {
          var l_arrCredentials = l_strSSoResponse.split('iamptseparator');
          console.log('Base URL: Get me log in SSO');
          if (l_arrCredentials.length > 1) {

            this.CheckVerifyUserLogin(l_arrCredentials[0], l_arrCredentials[1]);
          }
          else {
            if (!this.DefaultTS.IsLocal) {
              // **SSO**
              if (this.IsJLRSSO) {
                window.location.href = "https://auth.jlrmenabusinesstools.com/login?api=5";
              }
              else {
                window.location.href = "https://www.jlrmenabusinesstools.com/Login.aspx?lg=1";
              }
            }
            else {
              this.ShouldShowLogIn = true;
            }
          }
        }
        else if (l_strIsLogout) {
          if (!this.DefaultTS.IsLocal) {
            // **SSO**
            if (this.IsJLRSSO) {
              window.location.href = "https://auth.jlrmenabusinesstools.com/login?api=5";
            }
            else {
              window.location.href = "https://www.jlrmenabusinesstools.com/Login.aspx?lg=1";
            }
          }
          else {
            this.ShouldShowLogIn = true;
          }
          console.log('Base URL: Get me log out');
        }
        else
          this.VerifyUser(false, this.UserName, this.Password, false);
      }
    }
  }

  public GetMeLoggedOutAndRedirect() {
    let data = {} as any;

    this.http.post(this.baseUrl + 'api/SiteUser/LogoutUser', data).subscribe(result => {
      window.location.href = "https://auth.jlrmenabusinesstools.com/login?api=6";
    }, error => console.error(error));
  }


  public GetMeLoggedIn() {
    this.VerifyUser(false, this.UserName, this.Password, false);
  }
  public CheckVerifyUserLogin(p_strUserID, p_strPassword) {
    if (p_strUserID.length > 1 && p_strPassword.length > 1) {
      this.VerifyUser(true, p_strUserID, p_strPassword, false);
    }
    else {
      if (!this.DefaultTS.IsLocal) {
        window.location.href = "https://auth.jlrmenabusinesstools.com/login?api=5";
      }
      else {
        this.ShouldShowLogIn = true;
      }

      //  console.log('I was to be redirected to main');
      // this.VerifyUser(true, p_strUserID, p_strPassword);
    }

  }

  public VerifyUser(p_boolIsEncrypted, p_strUserName, p_strPassword, IsJLRSSO) {
    let data = {} as any;

    data.UserName = this.DefaultTS.SanitizerHTML(p_strUserName);
    data.Password = this.DefaultTS.SanitizerHTML(p_strPassword);
    data.IsEncrypted = p_boolIsEncrypted;
    data.IsJLRSSO = IsJLRSSO; // **SSO**
    this.DefaultTS.SetMasterAnimation(true);
    this.http.post(this.baseUrl + 'api/SiteUser/GetUserLogin', data).subscribe(result => {

      var l_arrResponse = result as any;
      if (l_arrResponse[0].Status == 1) {
        if (document.getElementById('spnLoggedinUser') != null)
          document.getElementById('spnLoggedinUser').innerText = l_arrResponse[0].UserName;
        //(<HTMLInputElement>document.getElementById('imgUserMain2')).src = l_arrResponse[0].ImageURL;
        //(<HTMLInputElement>document.getElementById('imgUserMain')).src = l_arrResponse[0].ImageURL;
        (<HTMLInputElement>document.getElementById('UserRole')).innerText = l_arrResponse[0].Role;

        if (l_arrResponse[0].Role == 'Admin' || l_arrResponse[0].Role == 'MasterAdmin')
          this.DefaultTS.IsAdmin = true;
        else if (l_arrResponse[0].Role == 'JLR' || l_arrResponse[0].Role == 'JLRReadOnly')
          this.DefaultTS.IsJLR = true;
        else if (l_arrResponse[0].Role == 'Dealer' || l_arrResponse[0].Role == 'DealerReadOnly')
          this.DefaultTS.IsDealer = true;

        this.DefaultTS.SiteUserID = l_arrResponse[0].SiteUserID;
        this.DefaultTS.UserEmail = l_arrResponse[0].UserEmail;
        this.DefaultTS.IsReadOnly = l_arrResponse[0].IsReadOnly;
        this.DefaultTS.IsFinanceManager = l_arrResponse[0].IsFinanceManager;
        this.DefaultTS.CanManageContentLibrary = l_arrResponse[0].CanManageLibrary;
        this.DefaultTS.IsTechnicalTrainer = l_arrResponse[0].IsTechnicalTrainer;
        this.DefaultTS.IsNonTechnicalTrainer = l_arrResponse[0].IsNonTechnicalTrainer;
        this.DefaultTS.IsResourceManager = l_arrResponse[0].IsResourceManager;
        this.DefaultTS.CanApproveAndSubmit = l_arrResponse[0].CanApproveAndSubmit;
        this.DefaultTS.AccessStatus = l_arrResponse[0].AccessStatus;
        this.DefaultTS.PFIDealerID = l_arrResponse[0].PFIDealerID;
        this.DefaultTS.IsNonTechnicalAssessor = l_arrResponse[0].IsNonTechnicalAssessor;
        this.DefaultTS.CanManageDashboardImage = l_arrResponse[0].CanManageDashboardImage;

        this.persistenceService.set('SiteUserID', this.DefaultTS.SiteUserID, { type: StorageType.SESSION });
        this.persistenceService.set('UserEmail', this.DefaultTS.UserEmail, { type: StorageType.SESSION });
        this.persistenceService.set('PFIDealerStorageID', this.DefaultTS.PFIDealerID, { type: StorageType.SESSION });
        this.persistenceService.set('IsReadOnly', this.DefaultTS.IsReadOnly, { type: StorageType.SESSION });
        this.persistenceService.set('CanManageContentLibrary', this.DefaultTS.CanManageContentLibrary, { type: StorageType.SESSION });
        this.persistenceService.set('IsFinanceManager', this.DefaultTS.IsFinanceManager, { type: StorageType.SESSION });
        this.persistenceService.set('IsTechnicalTrainer', this.DefaultTS.IsTechnicalTrainer, { type: StorageType.SESSION });
        this.persistenceService.set('IsNonTechnicalTrainer', this.DefaultTS.IsNonTechnicalTrainer, { type: StorageType.SESSION });
        this.persistenceService.set('IsResourceManager', this.DefaultTS.IsResourceManager, { type: StorageType.SESSION });
        this.persistenceService.set('IsNonTechnicalAssessor', this.DefaultTS.IsNonTechnicalAssessor, { type: StorageType.SESSION });
        this.persistenceService.set('CanManageDashboardImage', this.DefaultTS.CanManageDashboardImage, { type: StorageType.SESSION });

        this.BindAppList(l_arrResponse[0].AppList, l_arrResponse[0].DemoSite);

        var l_strRole = l_arrResponse[0].Role.toString().toLowerCase();
        if (this.DefaultTS.IsNonTechnicalAssessor && this.DefaultTS.AccessStatus != 1 && l_strRole.indexOf('admin') < 0)
          this.router.navigate(['/hrassessment']);
        else if (this.DefaultTS.IsDealer) {
          if (this.DefaultTS.DoesUserHaveAccess())
            window.location.href = "https://amtapp.jlrmenabusinesstools.com/dashboard";
          else
            window.location.href = "https://amtapp.jlrmenabusinesstools.com/dashboard";
        }
        else if (!this.ReturnURL || this.ReturnURL == '')
          window.location.href = "https://amtapp.jlrmenabusinesstools.com/dashboard";
        else
          window.location.href = this.ReturnURL;
      }
      else if (l_arrResponse[0].Status == 0) {
        if (document.getElementById('litMessage'))
          document.getElementById('litMessage').innerHTML = l_arrResponse[0].Message;
        this.ShouldShowLogIn = true;
      }
      else {
        var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
        if (isSafari) {
          this.ShouldShowLogIn = true;
        }
        else {

          if (this.l_boolIsSSO) {
            if (l_arrResponse[0].Status == 100) {
              console.log('Base URL: Get Logged in SSO ' + l_arrResponse[0].BaseURL);
              window.location.href = l_arrResponse[0].BaseURL;
            }
            else
              this.ShouldShowLogIn = true;
            console.log('Base URL: Get Logged in SSO in Normal way');
          }

          else {
            if (l_arrResponse[0].Status == 2) {
              document.getElementById('litMessage').innerText = '';
            }
            if (l_arrResponse[0].Status == 55) {
              if (!this.DefaultTS.IsLocal) {
                console.log('Base URL: First try in SSO ' + l_arrResponse[0].BaseURL);
                window.location.href = l_arrResponse[0].BaseURL;
              }
              else
                this.ShouldShowLogIn = true;
            }
            if (l_arrResponse[0].Status == 100) {
              if (!this.DefaultTS.IsLocal) {
                console.log('Base URL: First try in SSO ' + l_arrResponse[0].BaseURL);
                window.location.href = l_arrResponse[0].BaseURL;
              }
              else
                this.ShouldShowLogIn = true;
            }
          }
        }
      }
      this.DefaultTS.SetMasterAnimation(false);
    }, error => console.error(error));
  }


  public BindAppList(p_strAppList, p_strPrefix) {
    var l_strAppList = p_strAppList.split(',');

    if (p_strAppList.length > 0) {

      for (var k = 0; k < l_strAppList.length; k++) {

        this.DefaultTS.PTSetVisibilty('divBTApplication' + l_strAppList[k], true);
        var l_strLink = "";
        if (l_strAppList[k] == "1")
          l_strLink = "https://bpapp" + p_strPrefix + ".jlrmenabusinesstools.com";
        if (l_strAppList[k] == "2")
          l_strLink = "https://apost" + p_strPrefix + ".jlrmenabusinesstools.com";
        if (l_strAppList[k] == "3")
          l_strLink = "https://repscorecard" + p_strPrefix + ".jlrmenabusinesstools.com";
        if (l_strAppList[k] == "4")
          l_strLink = "https://ndtracker" + p_strPrefix + ".jlrmenabusinesstools.com";
        if (l_strAppList[k] == "5")
          l_strLink = "https://amt" + p_strPrefix + ".jlrmenabusinesstools.com/?sso=1";
        if (l_strAppList[k] == "6")
          l_strLink = "https://spt" + p_strPrefix + ".jlrmenabusinesstools.com/?sso=1";
        if (l_strAppList[k] == "7")
          l_strLink = "https://fleet" + p_strPrefix + ".jlrmenabusinesstools.com/?sso=1";
        if (l_strAppList[k] == "8")
          l_strLink = "https://serviceadvisor" + p_strPrefix + ".jlrmenabusinesstools.com/?sso=1";
        if (l_strAppList[k] == "9")
          l_strLink = "https://ibb" + p_strPrefix + ".jlrmenabusinesstools.com/?sso=1";

        if (document.getElementById("aBTApplication" + l_strAppList[k]) != null)
          document.getElementById("aBTApplication" + l_strAppList[k]).setAttribute('href', l_strLink);
      }

    }
    else {
      this.DefaultTS.PTSetVisibilty('aBusinessTools', false);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/Login/Login.ts